import React from 'react';

interface SVGProps {
  title?: string;
  titleId?: string;
  className: string;
}

const IconSeekPassSVGSmall = ({
  title,
  titleId,
  ...props
}: SVGProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" {...props}>
    <path
      d="M12.5359 3.57503L7.28585 0.658359C7.11085 0.559193 6.89502 0.559193 6.72002 0.658359L1.46419 3.57503C1.27752 3.68003 1.16669 3.87253 1.16669 4.08253V9.91586C1.16669 10.1259 1.28335 10.3242 1.46419 10.4234L6.71419 13.34C6.80169 13.3867 6.90085 13.4159 7.00002 13.4159C7.09919 13.4159 7.19252 13.3925 7.28585 13.34L12.5359 10.4234C12.7225 10.3184 12.8334 10.1259 12.8334 9.91586V4.08253C12.8334 3.87253 12.7167 3.67419 12.5359 3.57503Z"
      fill="#503DC9"
    />
    <path
      d="M6.41669 8.74991C6.26503 8.74991 6.11919 8.69158 6.00253 8.58074L4.42169 6.99991L5.24419 6.17741L6.41086 7.34408L8.74419 5.01074L9.56669 5.83324L6.81919 8.58074C6.70253 8.69741 6.55669 8.74991 6.40503 8.74991H6.41669Z"
      fill="white"
    />
  </svg>
);

export default IconSeekPassSVGSmall;
